import * as Sentry from '@sentry/react'

// REACT_APP_SENTRY_ENABLED=false (or 0, off, no) turns Sentry off without removing the DSN.
const disabled = ['false', '0', 'off', 'no'].includes(
	(process.env.REACT_APP_SENTRY_ENABLED || '').trim().toLowerCase()
)
const dsn = !disabled && process.env.REACT_APP_SENTRY_DSN

/**
 * Starts Sentry error tracking. Does nothing without REACT_APP_SENTRY_DSN or with
 * REACT_APP_SENTRY_ENABLED=false, so local builds send no data.
 *
 * @returns {void}
 */
export const initSentry = () => {
	if (!dsn) return

	Sentry.init({
		dsn,
		environment:
			process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
		release: process.env.REACT_APP_SENTRY_RELEASE,
		// No IP addresses or cookies. The user is set explicitly in setSentryUser.
		sendDefaultPii: false,
		// Errors only, no performance tracing or session replay.
		tracesSampleRate: 0,
	})
}

/**
 * Sends a caught error to Sentry, with extra context for the issue page.
 *
 * @param {Error} error - The caught error.
 * @param {Object} [context] - Extra data, shown under "Additional Data" in Sentry.
 * @returns {void}
 */
export const captureError = (error, context) => {
	if (!dsn) return
	Sentry.captureException(error, { extra: context })
}

/**
 * Attaches the logged-in user to all following Sentry events, so issues can be
 * filtered per user (e.g. `user.username:max`). Pass null on logout.
 *
 * @param {Object|null} profile - The profile from /Users/Profile, or null.
 * @param {String} [instance] - The shortLink of the IOTA instance (e.g. "sens").
 * @returns {void}
 */
export const setSentryUser = (profile, instance) => {
	if (!dsn) return
	if (!profile) {
		Sentry.setUser(null)
		return
	}
	Sentry.setUser({
		id: profile.id ?? profile.userId ?? profile.username,
		username: profile.username,
	})
	Sentry.setTag('instance', instance)
}
